import React from 'react';

import { ITimelineChartProps } from '../../../../interfaces/charts';
import { toLocaleNumberFormat } from '../../../../utils/utils';

import './TimelineChart.scss';

const TimelineChart = ({ IconComponent, elements, title }: ITimelineChartProps) => {
  return (
    <div className="timeline-chart" data-experience="new">
      <div className="timeline-origin relative flex items-center justify-center rounded-full">
        <div className="timeline-title absolute text-center uppercase">{title}</div>
        <IconComponent className="timeline-icon" />
      </div>
      <div className="timeline-line absolute w-full"></div>
      <div className="timeline-elements flex flex-row items-center justify-around">
        {elements.map((element) => (
          <div key={element.timeLabel} className="element">
            <div className="dot rounded-full"></div>
            <div className="data absolute flex flex-column items-center gap-5">
              <div className="element-value">
                {element.value > 0 ? `+${toLocaleNumberFormat(element.value)}` : toLocaleNumberFormat(element.value)}
              </div>
              <div className="element-label">{element.timeLabel}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TimelineChart;
